import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { configService } from '../services/api';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [logoUrl, setLogoUrl] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const url = configService.getLogoUrl();
    fetch(url).then(r => { if (r.ok) setLogoUrl(url + '?t=' + Date.now()); }).catch(()=>{});
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => { logout(); navigate('/'); };
  const active = path => location.pathname === path;

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      await configService.uploadLogo(file);
      setLogoUrl(configService.getLogoUrl() + '?t=' + Date.now());
      alert('✅ Logo actualizado correctamente');
    } catch (err) {
      alert('Error al subir el logo');
    }
  };

  const navBtn = (isActive) => ({
    background: isActive ? '#a0522d' : 'transparent',
    color: '#fff',
    border: 'none',
    padding: isMobile ? '10px 0' : '6px 12px',
    borderRadius: isMobile ? 0 : 6,
    cursor: 'pointer',
    fontSize: isMobile ? 11 : 13,
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    alignItems: 'center',
    gap: isMobile ? 3 : 5,
    flex: isMobile ? 1 : 'none',
    borderBottom: isActive ? '3px solid #f59e0b' : '3px solid transparent',
  });

  return (
    <>
      <nav style={{
        background: '#5c3d2e',
        color: '#fff',
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 54,
        position: 'sticky',
        top: 0,
        zIndex: 100,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}>
        <div
          style={{ fontWeight: 800, fontSize: 17, letterSpacing: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
          onClick={() => navigate('/dashboard')}
        >
          {logoUrl
            ? <img src={logoUrl} alt="Logo" style={{ height: 38, objectFit: 'contain' }} onError={() => setLogoUrl(null)} />
            : <span>🪑</span>
          }
          {!isMobile && <span>Terrasol</span>}
        </div>

        {!isMobile && (
          <div style={{ display: 'flex', gap: 4 }}>
            {user?.role !== 'inventario' && <button style={navBtn(active('/dashboard'))} onClick={() => navigate('/dashboard')}>📊 Órdenes</button>}
            {['admin','vendedor'].includes(user?.role) && <button style={navBtn(active('/nueva-orden'))} onClick={() => navigate('/nueva-orden')}>+ Nueva Orden</button>}
            {['admin','vendedor'].includes(user?.role) && <button style={navBtn(active('/clientes'))} onClick={() => navigate('/clientes')}>👥 Clientes</button>}
            {['admin','vendedor','inventario'].includes(user?.role) && <button style={navBtn(active('/inventario'))} onClick={() => navigate('/inventario')}>📦 Inventario</button>}
          </div>
        )}

        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {user?.role === 'admin' && (
            <label style={{ background: '#a0522d', color: '#fff', border: 'none', padding: '5px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11 }}>
              {isMobile ? '🖼️' : '🖼️ Cambiar logo'}
              <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleLogoUpload} />
            </label>
          )}
          <span style={{ fontSize: 12, opacity: 0.8 }}>👤 {isMobile ? user?.name?.split(' ')[0] : user?.name}</span>
          <button
            style={{ background: '#c0392b', color: '#fff', border: 'none', padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}
            onClick={handleLogout}
          >Salir</button>
        </div>
      </nav>

      {isMobile && (
        <div style={{
          background: '#5c3d2e',
          display: 'flex',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          position: 'sticky',
          top: 54,
          zIndex: 99,
        }}>
          {user?.role !== 'inventario' && (
            <button style={navBtn(active('/dashboard'))} onClick={() => navigate('/dashboard')}>
              <span style={{ fontSize: 18 }}>📊</span>
              <span>Órdenes</span>
            </button>
          )}
          {['admin','vendedor'].includes(user?.role) && (
            <button style={navBtn(active('/nueva-orden'))} onClick={() => navigate('/nueva-orden')}>
              <span style={{ fontSize: 22, color: "#f59e0b", fontWeight: "bold", lineHeight: 1 }}>+</span>
              <span>Nueva Orden</span>
            </button>
          )}
          {['admin','vendedor'].includes(user?.role) && (
            <button style={navBtn(active('/clientes'))} onClick={() => navigate('/clientes')}>
              <span style={{ fontSize: 18 }}>👥</span>
              <span>Clientes</span>
            </button>
          )}
          {['admin','vendedor','inventario'].includes(user?.role) && (
            <button style={navBtn(active('/inventario'))} onClick={() => navigate('/inventario')}>
              <span style={{ fontSize: 18 }}>📦</span>
              <span>Inventario</span>
            </button>
          )}
        </div>
      )}
    </>
  );
}
